<p>customer-personalization-email-setup works!</p>
